import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const shivaProperty = new SummonDataProperty(
  "d2a2e3ac-d11d-44a7-ae6c-070260e8930d",
  "Shiva",
)
